import { render, staticRenderFns } from "./DisplaySpinNumber.vue?vue&type=template&id=1b09381a&"
import script from "./DisplaySpinNumber.vue?vue&type=script&lang=js&"
export * from "./DisplaySpinNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports